// extracted by mini-css-extract-plugin
export var author = "sidebar-module--author--9eff6";
export var category = "sidebar-module--category--6c3e2";
export var headline = "sidebar-module--headline--fc552";
export var headlinePost = "sidebar-module--headline-post--d7397";
export var image = "sidebar-module--image--fc709";
export var newsletter = "sidebar-module--newsletter--5ec33";
export var paragraph = "sidebar-module--paragraph--cd346";
export var sidebar = "sidebar-module--sidebar--8a476";
export var socialMediaIcon = "sidebar-module--social-media-icon--cfd4a";
export var socialMediaList = "sidebar-module--social-media-list--a37aa";